<template>
  <section class='leaveStu'>

    <Row xs="20" sm="16" md="12" lg="8">
      <Col span='4'>
      <Input v-model="searchParam.title" placeholder="新闻标题" />
      </Col>

      <Col span='1'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>
      <ul class='conheadRight'>
        <i-button type="error" @click='removeAll' style='margin-right:10px;'
          v-if='selectList.length > 0'>批量删除</i-button>
        <i-button type="error" @click='sModal(-1)'>发布新闻</i-button>
      </ul>
    </Row>

    <Row id='pdData' class='pdData'>
      <div v-for='(item, index) in pdData' class='itempd' :class='[index == curIndex ? "active" : ""]' :key="item.guid"
        @click='tabPD(index, item, 1)'>{{ item.name }}</div>
    </Row>
    <Row id='pdData2' class='pdData' v-if='pdData2.length > 0'>
      <div v-for='(item, index1) in pdData2' class='itempd' :class='[index1 == curIndex1 ? "active" : ""]'
        :key="item.guid" @click='tabPD(index1, item, 2)'>{{ item.name }}</div>
    </Row>
    <!-- <Row id='pdData3' class='pdData' v-if='pdData3.length > 0'>
      <div v-for='(item, index2) in pdData3' class='itempd' :class='[index2 == curIndex2 ? "active" : ""]'
        @click='tabPD(index2, item, 3)'>{{ item.name }}</div>
    </Row> -->
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' @selectLcd='selectLcd' :isdrag='isdragd'
        :issearch='issearch' @smodal='sModal'>
      </tablePage>
    </section>

    <Modal v-model="edit" title='新闻发布/修改' fullscreen :mask-closable='false'>

      <section class='commonCon'>
        <Form :model="formItem" :label-width="80" :rules="ruleValidate">
          <section id='con' @click='hideInput'>
            <section class='ConLeft'>
              <Form-item label="标题" prop="title">
                <Input v-model="formItem.title" placeholder="请输入新闻标题，最佳显示字数36字以为"></Input>
              </Form-item>
              <!-- <Form-item label="详情标题">
                <Input v-model="formItem.detialtitle" type='textarea' placeholder="不限制字数，资讯详情将显示改标题，留空则沿用新闻标题"></Input>
              </Form-item> -->

              <Row type="flex" justify="space-between" class="code-row-bg">

                <Col span="12">
                <Form-item label="所属栏目" prop='title'>
                  <selftree :treedata='lanmu' :treekey="treekey" @click.stop='' :ischeck='true'
                    :hideInputNum='hideInputNum' @changeClass='changeRenke'></selftree>
                </Form-item>
                </Col>
                <Col span="12">
                <Form-item label="来源" prop="source">
                  <!-- <Input v-model="formItem.source" placeholder="请输入"></Input> -->
                  <AutoComplete v-model="formItem.source" :data="datasource" placeholder="若不填则默认为太湖新城楼宇会">
                  </AutoComplete>
                </Form-item>
                </Col>
              </Row>
              <!-- <Row type="flex" justify="space-around" class="code-row-bg">
                <Col span="12">
                <Form-item label="作者">
                  <Input v-model="formItem.auther" placeholder="请输入"></Input>
                </Form-item>
                </Col>
                <Col span="12">
                <Form-item label="编辑">
                  <Input v-model="formItem.editor" placeholder="编辑多个，请用空格隔开"></Input>
                </Form-item>
                </Col>
              </Row> -->
              <Row type="flex" justify="space-around" class="code-row-bg">

                <Col span="12">
                <Form-item label="责任编辑">
                  <Input v-model="formItem.owner" placeholder="责任编辑多个，请用空格隔开"></Input>
                </Form-item>
                </Col>
                <Col span="9">
                <Form-item label="添加时间">
                  <Date-picker type="datetime" size='default' :editable="isableedit" :clearable="isableedit"
                    v-model='formItem.pubtime' format="yyyy-MM-dd HH:mm">
                  </Date-picker>
                </Form-item>
                </Col>
                <Col span="3">
                &nbsp;&nbsp;&nbsp;
                <Button @click='dsgetCurtime'>当前时间</Button>
                </Col>
              </Row>
              <Form-item prop="name" label="发布类型">
                <RadioGroup v-model="formItem.showtype">
                  <Radio label="1">新闻</Radio>
                  <Radio label="2">文档</Radio>
                  <Radio label="3">音频</Radio>
                  <Radio label="4">视频</Radio>
                </RadioGroup>
              </Form-item>
              <Row type="flex" justify="space-around" class="code-row-bg" v-if="formItem.showtype != 1">

                <Col span="19">
                <Form-item prop="name" label="地址">
                  <Input v-model="formItem.thum" placeholder="请输入地址或点击上传"></Input>
                </Form-item>
                </Col>
                <Col span="2">
                </Col>
                <Col span="3">
                <Upload ref="upload222" :on-success='fileSUccess3' :show-upload-list="false" :action="upurl">
                  <Button icon="ios-cloud-upload-outline">上传</Button>
                </Upload>
                </Col>
              </Row>
              <Form-item prop="name" label="封面图片" v-if="formItem.showtype == 1">
                <input type="hidden" v-model='formItem.thum'>
                <upImg @upImglist='upImglist' :extradata='extradata' :max-len='imglen' :defaultimg='formItem.thum'>
                </upImg>

                <!-- <p style='color:#e22a1c' v-if='formItem.showtype == 1 || formItem.showtype == 2'>图片尺寸：330*216</p>
                <p style='color:#2db7f5' v-if='formItem.showtype == 3'>图片尺寸：686*160</p>
                <p style='color:#00d186' v-if='formItem.showtype == 4 || formItem.showtype == 5'>图片尺寸：686*386</p> -->

                <!--   <img src="" alt="" v-for='items in conImgList' :src='items' style='width:40px;height:30px;'> -->
                <Button @click='getConImg(0)' icon="md-image">抓取正文图片</Button>
                <Button @click='getfromAssest(0)' style='margin-left:10px' icon="md-cloud">从资源库中选择</Button>
              </Form-item>
              <!-- <Row type="flex" justify="space-around" class="code-row-bg">
                <Col span="11">
                <Form-item prop="name" label="海报图片（横图）">
                  <input type="hidden" v-model='formItem.pic1'>
                  <upImg @upImglist='upImglist1' :extradata='extradata' :max-len='imglen' :defaultimg='formItem.pic1'>
                  </upImg>
                  <p style='color:#e22a1c'>750*420</p>

                  <Button @click='getConImg(2)' icon="md-image">抓取正文图片</Button>
                  <Button @click='getfromAssest(2)' style='margin-left:10px' icon="md-cloud">从资源库中选择</Button>
                </Form-item>
                </Col>
                <Col span="2">

                </Col>
                <Col span="11">
                <Form-item prop="name" label="海报图片（竖图）">
                  <input type="hidden" v-model='formItem.pic2'>
                  <upImg @upImglist='upImglist2' :extradata='extradata' :max-len='imglen' :defaultimg='formItem.pic2'>
                  </upImg>
                  <p style='color:#e22a1c'>图片尺寸：610*864</p>
                  <Button @click='getConImg(3)' icon="md-image">抓取正文图片</Button>
                  <Button @click='getfromAssest(3)' style='margin-left:10px' icon="md-cloud">从资源库中选择</Button>
                </Form-item>
                </Col>
              </Row> -->

              <Row type="flex" justify="space-around" class="code-row-bg" v-if="formItem.showtype == 1">

                <Col span="12">
                <Form-item prop="name" label="打开方式">
                  <RadioGroup v-model="formItem.linktype">
                    <Radio label="0">内部</Radio>
                    <Radio label="1">跳转外链</Radio>
                  </RadioGroup>
                </Form-item>
                </Col>
                <Col span="12">
                <!--  <Form-item  label="新闻类型" v-if='formItem.linktype=="0"'>
                  <RadioGroup v-model="newstype">
                    <Radio label="0">图文新闻</Radio>
                    <Radio label="1">视频新闻</Radio>
                  </RadioGroup>
                </Form-item> -->
                </Col>
              </Row>

              <Form-item label="" v-if='formItem.linktype == "1"'>
                <Input v-model="formItem.url" placeholder="请输入"></Input>
              </Form-item>
              <!-- <Form-item label="列表摘要">
                <Input v-model="formItem.summary" placeholder="请输入"></Input>
              </Form-item>
              <Form-item label="关键字">
                <Input v-model="formItem.keyword" placeholder="用于相关新闻推荐匹配同时为上传资源加上标签，多个关键词，用逗号分割"></Input>
              </Form-item> -->
              <!-- <Row type="flex" justify="space-around" class="code-row-bg">
                <Col span="12">
                <Form-item label="访问量">
                  <InputNumber v-model="formItem.vewcnt" placeholder="输入需增加的访问量"></InputNumber>
                </Form-item>
                </Col>
                <Col span="12">
                </Col>
              </Row> -->
              <!-- <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="4">
                <Form-item label="显示广告">
                  <i-switch v-model="formItem.isinsideadv" size="large">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </Form-item>
                </Col>
                <Col span="4">
                <Form-item label="能否评论">
                  <i-switch v-model="formItem.enableComment" size="large">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </Form-item>
                </Col>
                <Col span="4">
                <Form-item label="能否点赞">
                  <i-switch v-model="formItem.enablelike" size="large">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </Form-item>
                </Col>
                <Col span="4">
                <Form-item label="是否置顶">
                  <i-switch v-model="formItem.istop" size="large">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </Form-item>
                </Col>
                <Col span="4">
                <Form-item label="是否原创">
                  <i-switch v-model="formItem.isoriginal" size="large">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </Form-item>
                </Col>
              </Row> -->
              <Row type="flex" justify="space-around" class="code-row-bg">

                <Col span="11">
                <Form-item label="定时发布">
                  <Checkbox v-model="ordertime"></Checkbox>

                </Form-item>
                </Col>
                <Col span="11">
                <Form-item label="发表时间" v-if='ordertime'>
                  <Date-picker type="datetime" size='default' v-model='formItem.showtime' format="yyyy-MM-dd HH:mm">
                  </Date-picker>
                </Form-item>
                <!-- <Button>当前时间</Button> -->
                </Col>

              </Row>


            </section>
            <section class='ConRight'>
              <testeditor @editorContent='editorContent' @clicktool='clicktool' :nr='formItem.content'
                :addtings='addtings' v-show='formItem.linktype == "0" && formItem.showtype != "5"'></testeditor>
              <FormItem label="视频" v-show='formItem.linktype == "0" && formItem.showtype == "5"'>
                <video id="myvideo" width="100%" height="auto" :src="formItem.videourl" controls="controls"
                  style="display:inline;">
                  <source id="tv" type="video/mp4" :src="formItem.videourl">
                  视频
                  </source>
                  您的浏览器不支持video标签
                </video>
                <Upload :action="actionUrl" :format="['mp4']" :on-success='upVideo' :on-format-error="handleFormatError"
                  ref="videoUpload">
                  <Button icon="ios-cloud-upload-outline">上传视频</Button>
                </Upload>
              </FormItem>

              <div style='width:100%;height:100%;margin:0 auto;padding:0px 10px;overflow:hidden;'
                v-show='formItem.linktype == "1"'>
                <iframe :src="formItem.url" frameborder='0' width="100%" height="100%"></iframe>
              </div>

            </section>
          </section>
        </Form>
      </section>
      <div slot="footer" style='position:relative;clear:both'>

        <Button type="error" @click='removeItem' class='remove' icon="md-trash"
          v-if='this.formItem.id != ""'>删除</Button>
        <Button type="default" @click='edit = false' icon="md-close">取消</Button>
        <Button type="info" @click='postNews()' icon="md-checkmark-circle-outline">保存</Button>
      </div>
    </Modal>
    <Modal v-model='showpicModal' width='1000' title='图片裁剪1' :mask-closable='false'>
      <div id='croppicConten'>
        <ul>
          <li v-for='(item, index) in conImgList' :class='[index == curImgIndex ? "active" : ""]'
            @click='setUrl(item, index)' :key="index">
            <img :src="item" alt="">
          </li>
        </ul>
        <div style='width:820px;height:500px;' v-if="showpicModal">
          <vueCropper ref="cropper2" :img="example2.img" :outputSize="example2.size" :outputType="example2.outputType"
            :info="example2.info" :canScale="example2.canScale" :autoCrop="example2.autoCrop"
            :autoCropWidth="example2.autoCropWidth" :canMove='example2.canMove'
            :autoCropHeight="example2.autoCropHeight" :fixed="example2.fixed" :fixedNumber="example2.fixedNumber"
            :enlarge="4" :maxImgSize='example2.maxImgSize'>
          </vueCropper>
          <!-- <label class="btn" for="upload2">上传</label>
          <input type="file" id="upload2" style="position:absolute; clip:rect(0 0 0 0);"
            accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event,2)">
          <button @click="finish2()" class="btn">裁剪</button> -->
        </div>
      </div>
      <div slot="footer" style='position:relative;clear:both'>

        <Button type="info" @click='finish2' icon="md-checkmark-circle-outline">确认</Button>


      </div>
    </Modal>
    <Modal v-model='showpicModal2' width='1000' title='图片裁剪' :mask-closable='false'>
      <div id='croppicConten'>
        <ul>
          <li v-for='(item, index) in conImgList' :class='[index == curImgIndex ? "active" : ""]'
            @click='setUrl(item, index)' :key="index">
            <img :src="item" alt="">
          </li>
        </ul>
        <div style='width:820px;height:900px;' v-if="showpicModal2">
          <vueCropper ref="cropper3" :img="example2.img" :outputSize="example2.size" :outputType="example2.outputType"
            :info="example2.info" :canScale="example2.canScale" :autoCrop="example2.autoCrop"
            :autoCropWidth="example2.autoCropWidth" :canMove='example2.canMove'
            :autoCropHeight="example2.autoCropHeight" :fixed="example2.fixed" :fixedNumber="example2.fixedNumber"
            :enlarge="4" :maxImgSize='example2.maxImgSize'>
          </vueCropper>
          <!-- <label class="btn" for="upload2">上传</label>
          <input type="file" id="upload2" style="position:absolute; clip:rect(0 0 0 0);"
            accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event,2)">
          <button @click="finish2()" class="btn">裁剪</button> -->
        </div>
      </div>
      <div slot="footer" style='position:relative;clear:both'>

        <Button type="info" @click='finish3' icon="md-checkmark-circle-outline">确认</Button>


      </div>
    </Modal>
    <Drawer v-model="showNewsModal" title='新闻预览' width='600' id='drawer'>

      <div style='width:100%;height:100%;margin:0 auto;padding:0px;overflow:hidden;'>
        <canvas id="QRCode_header"></canvas>
        <Button type="primary" id='copyLink' class='cobyOrderSn' :data-clipboard-text="curNews.url"
          @click="copyLink">复制链接</Button>
        <!-- <span  class="cobyOrderSn" id='copyLink' :data-clipboard-text="curNews.url" @click="copyLink">复制链接</span> -->
        <iframe :src="curNews.url" frameborder='0' width="100%" height="100%"></iframe>
      </div>
    </Drawer>
    <Modal v-model='assestModal' fullscreen width='900' title='资源库' :mask-closable='false'>
      <div id='assestCon'>
        <Tabs :value="listtabname" @on-click='switchFileType' style='margin-bottom:80px;padding-right:20px;'>

          <TabPane label="公共资源" name="yiyue">

            <ul class='gallerylist' style='position:relative' v-if='gwlisted.length > 0'>
              <li v-for='(item, index) in gwlisted' class='' @click='rowData(item, index, 1)' :key="index"
                v-if='item.filetype == assestType'>
                <div>
                  <div class='gallerylistcontent'>

                    <img :src="item.url" alt="" v-if='item.filetype == 0'>
                    <video id="myvideo" :src="item.url" controls="controls" v-else-if='item.filetype == 2'>
                      <source id="tv" type="video/mp4" :src="item.url">
                      视频
                      </source>
                      您的浏览器不支持video标签
                    </video>
                    <audio :src="item.url" controls v-if='item.filetype == 1'></audio>

                    <h4></h4>
                    <div>

                      <p>{{ item.filename }} </p>
                      <div>上传于：{{ item.addtime }}</div>
                    </div>
                  </div>
                  <!-- <div class='removePhoto'>
         		    	<Checkbox size='small' v-model='item.ischeck'>&nbsp;</Checkbox>
         		    </div> -->
                </div>

              </li>
            </ul>
          </TabPane>
          <TabPane label="我的资源" name="weiyue">
            <ul class='gallerylist' style='position:relative'>

              <li v-for='(item, index) in gwlist' class='' :key="index" @click='rowData(item, index, 0)'
                v-if='item.filetype == assestType'>
                <div>
                  <div class='gallerylistcontent'>

                    <img :src="item.url" alt="" v-if='item.filetype == 0'>
                    <video id="myvideo" :src="item.url" :poster='item.poster' controls="controls"
                      v-else-if='item.filetype == 2'>
                      <source id="tv" type="video/mp4" :src="item.url">
                      视频
                      </source>
                      您的浏览器不支持video标签
                    </video>
                    <audio :src="item.url" controls v-if='item.filetype == 1'></audio>

                    <h4></h4>
                    <div>

                      <p>{{ item.filename }} </p>
                      <div>上传于：{{ item.addtime }}</div>
                    </div>
                  </div>
                </div>

              </li>
              <Spin fix size="large" v-if="spinShow"></Spin>
            </ul>


          </TabPane>
          <RadioGroup v-model="assestType" @on-change='changeAssType' slot='extra'>
            <Radio label="0">图片</Radio>
            <Radio label="1">音频</Radio>
            <Radio label="2">视频</Radio>
            <Radio label="3">文档</Radio>
          </RadioGroup>
        </Tabs>
      </div>
      <div slot="footer" style='position:relative;clear:both'>



      </div>
    </Modal>

    <Modal v-model="newGWMadel" title='上传资源'>
      <Form :model="newGWData" label-position="top">
        <FormItem label="添加方式" class=''>
          <RadioGroup v-model="choseSource" @on-change='changeSource'>
            <Radio label="0">本地</Radio>
            <Radio label="1">网络</Radio>
            <Radio label="2">资源库</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="上传" v-if='choseSource == "0"'>
          <!-- :action="actionUrl"> -->
          <Upload ref="upload" :on-success='fileSUccess' :before-upload='beforeload' type="drag" :action="upurl">
            <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>点击或拖拽文件到这里上传</p>
            </div>
          </Upload>
        </FormItem>
        <p v-if='hadposter == 2' style='color:orangered'>请继续上传视频播放封面图片</p>
        <FormItem label="网络地址" v-if='choseSource == "1"'>
          <Input v-model="newGWData.url" placeholder="请输入"></Input>
        </FormItem>
        <FormItem label="文件名称" v-if='hadposter == 4'>
          <Input v-model="newGWData.name" placeholder="请输入"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <p class='exp'>可上传图片、视频、音频、pdf文档。</p>
        <Button type="default" @click='newGWMadel = false' icon="md-close">取消</Button>
        <Button type="info" @click='postNewGW' icon="md-checkmark-circle-outline" :disabled='disbtn'>插入</Button>

      </div>
    </Modal>
    <!-- <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal> -->
  </section>
</template>

<script>

import testeditor from './test'
import selftree from './inputTree'
import utilMethod from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
import upImg from './upImgnew'
import QRCode from 'qrcode'

import {
  VueCropper
} from 'vue-cropper'
export default {
  name: 'newslist',
  watch: {
    curIndex (newval, oldval) {
      this.isdragd = newval == 0 ? false : true
    },
    tabnindex: {

      handler (newval, oldval) {
        console.log(newval, oldval, 'nold')
        var _index = newval['idx']
        this.getItemByData(_index)
      },
      deep: true
    },
  },
  props: {
    tabnindex: {
      type: Object,
      default: () => { },
    }
  },
  components: {
    tablePage,
    bemodal,
    selftree,
    VueCropper,
    upImg,
    testeditor,
  },
  data () {
    return {
      queryzyData: ['media/getQueryList',
        [
          {
            title: '资源',
            key: '',
            width: 150,
            render: (h, params) => {


              var styles = {//设置样式
                display: 'inline-block',
                width: '100px',
                height: '60px',
                borderRadius: '3px',
                textAlign: 'center',
                lineHeight: '60px',
                marginRight: '3px'
              }
              var _filetype = params.row.url.split('.')
              var _type = this.getfiletype(_filetype[_filetype.length - 1])

              if (_type == 0) {
                var _pics = params.row.url.split(',')
                var imgs = []
                _pics.map(function (val, index) {
                  imgs.push(h('img', { style: styles, attrs: { src: val } }))
                })

                return h('viewer', imgs)
              } else {
                if (_type == '2') {
                  var _videourl = params.row.url.split('&')[1]
                  var _poster = params.row.url.split('&')[0]
                  return h('video', { style: { width: '150px', height: '100px' }, attrs: { controls: "controls", poster: _poster } }, [h('source', { style: { width: '50px', height: '50px' }, attrs: { src: _videourl } })])
                } else {
                  return h('video', { style: { width: '150px', height: '100px' }, attrs: { controls: "controls" } }, [h('source', { style: { width: '50px', height: '50px' }, attrs: { src: params.row.url } })])
                }

              }


            }

          },

        ]
      ],
      searchzyParam: {
        ispublic: 0,
      },
      issearchzy: -1,
      picwater: '1',
      datasource: [],
      disbtn: true,
      choseSource: '0',
      newGWMadel: false,
      newGWData: {
        url: '',
        filetype: 0,
        name: '',
      },
      spinShow: false,
      assestType: '0',
      gwlist: [],
      gwlisted: [],
      gallery: [],
      listtabname: 'yiyue',
      assestModal: false,
      curIndex1: 0,
      curIndex2: 0,
      curNews: {
        title: '',
        url: '',
      },
      showNewsModal: false,
      mewsto: ['isapp'],
      isdragd: false,
      editContent: '', // 富文本
      curImgIndex: 0,
      showpicModal: false,
      showpicModal2: false,
      example2: {
      },
      storeimg: [],
      storeimg1: [],
      storeimg2: [],
      actionUrl: '',
      newstype: '0',
      ordertime: false,
      animal: '0',
      curIndex: 0,
      imglen: 3,
      hideInputNum: -1,
      treekey: -1,
      extradata: {
        type: 'gallery'
      },
      lanmu: [],
      initformItem: [],
      isableedit: false, //是否可编辑
      formItem: {
        isoriginal: false,   // 是否原创
        detialtitle: '', //详情标题
        auther: '', //作者
        editor: '', //编辑
        linktype: '0', // 0 内联 1 外联
        showtype: '1', // 列表展现方式 1 单 2 多 3 长 4 大 5 视频 6 无图
        thum: '', //缩略图
        summary: '', //摘要
        keyword: '', //关键字
        pubtime: '', //发表时间
        vewcnt: 1000, //访问量
        isinsideadv: true, // 是否有页内广告 0 否 1 是
        enableComment: true, // 0 不可评论 1 可
        enablelike: true, // 0 不可点赞  1可
        ispush: 0,//开启推送 0 不推  1推
        pic1: '', //海报图片1
        pic2: '',//海报图片2
        id: '',
        title: '',
        content: '',
        itemid: [],
        url: '',
        videourl: '',
        pic: '',
        owner: '',
        source: '',
        showtime: '',
        departid: [],
        topic: [],
        guid: '',
        state: true,
        isweb: false,
        isapp: false
      },
      ruleValidate: {
        title: [{
          required: true,
          message: '请填写标题',
          trigger: 'blur'
        }],
        source: [{
          required: true,
          message: '请填写来源',
          trigger: 'blur'
        }],
        itemid: [{
          required: true,
          message: '请选择栏目',
          trigger: 'change'
        }],
      },
      edit: false,
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      formData: [
        ['news/getId', 'news/save', 'news/delete'],
        [{
          type: 'input',
          title: '标题',
          name: 'name',
          model: '',
          block: true,
        },
        {
          type: 'input',
          title: '作者',
          name: 'owner',
          model: '',
          block: true,
        },
        {
          type: 'input',
          title: '分类',
          name: 'amount',
          model: 0,
          block: true,
        },
        {
          type: 'input',
          title: '来源',
          name: 'source',
          model: '',
          block: true,
        },
        {
          type: 'input',
          title: '超链接',
          name: 'url',
          model: '',
          block: true,
        },
        {
          type: 'input',
          title: '视频路径',
          name: 'videourl',
          model: '',
          block: true,
        },
        {
          type: 'numberInput',
          title: '新闻数量',
          name: 'num',
          model: 1,
          block: true,
        },
        {
          type: 'switch',
          title: '状态',
          name: 'state',
          model: false,
          block: true,
        },
        {
          type: 'textarea',
          title: '新闻描述',
          name: 'gooddesc',
          model: ''
        },

        {
          type: 'uploadimg',
          title: '新闻封面',
          name: 'pic',
          pictype: {
            type: 'gallery'
          },
          model: ''
        },
        {
          type: 'hidden',
          children: [{
            name: 'guid',
            model: ''
          }]
        }
        ]
      ],
      queryData: ['news/getQueryList',
        [{
          type: 'selection',
          width: 60,
          align: 'center'
        }, {
          title: '标题',
          key: '',
          render: (h, params) => {
            var _zd = {
              style: {
                color: "#ed4c78",
                backgroundColor: "rgba(237,76,120,.1)",
                padding: "2px 8px",
                borderRadius: '7px',
                fontSize: '11px',
                display: 'inline-block',
                marginRight: '4px',
              }
            }
            var viewcnt = {
              style: {
                background: '#f5f5f5',
                color: '#515a6e',
                padding: "2px 8px",
                borderRadius: '7px',
                fontSize: '10px',
                display: 'inline-block',
                marginRight: '4px',
                marginLeft: '8px'
              }
            }
            if (params.row.istop == 1) {
              return h('div', [
                h('span', _zd, '置顶'),
                h('strong', { style: { fontWeight: 'bold' }, }, params.row.title),
                h('span', viewcnt, params.row.readcnt)
              ])


            } else {
              return h('div', [
                h('strong', {
                  style: {
                    fontWeight: 'bold'
                  },
                }, params.row.title),
                h('span', viewcnt, params.row.readcnt)
              ])


            }
          }
        },
        {
          title: '编辑',
          key: 'editor',
          width: 150,
          align: 'center',
          render: (h, params) => {


            return h('span', {
              style: {
                fontSize: '11px'
              },
            }, params.row.editor)


          }
        },

        {
          title: '添加时间',
          key: 'pubtime',
          width: 140,
          align: 'center',
        },
        {
          title: '发布时间',
          key: 'showtime',
          width: 140,
          align: 'center',
        },
        // {
        //   title: '发布到',
        //   key: '',
        //   width: 90,
        //   align: 'center',
        //   render: (h, params) => {

        //     var isapp = params.row.isapp
        //     var isweb = params.row.isweb

        //     var isppicon =h('icon', {
        //                       props: {
        //                         type: "md-phone-portrait",
        //                         size: '15'
        //                       },

        //                     })
        //     var iswebicon = h('icon', {
        //                       props: {
        //                         type: "md-desktop",
        //                         size: '15'
        //                       },
        //                     })
        //     if(isapp == 1 && isweb == 1){
        //         return  h('div',[isppicon,iswebicon])
        //     }else if(isapp ==1 && isweb == 0){
        //         return  h('div',[isppicon ])
        //     }else if(isapp ==0 && isweb ==1){
        //         return  h('div',[iswebicon])
        //     }else{
        //         return  h('div',[])
        //     }
        //   }
        // },
        {
          title: '状态',
          key: 'state',
          width: 80,
          align: 'center',
          render: (h, params) => {

            var _state = params.row.state
            if (_state == 1) {
              return h('span', {
                style: {
                  color: " #00d186",
                },
              }, '已发布')
            } else {
              return h('span', {
                style: {
                  color: " #ed4c78",
                },
              }, '未发布')
            }

          }
        },
        {
          title: '操作',
          slot: 'action',
          width: 90,
          align: 'center',
          render: (h, params) => {
            var that = this
            var _state = params.row.state == 0 ? '发布' : '取消发布'
            var _tuisong = false
            var showtime = params.row.showtime ? params.row.showtime.split('.0')[0] : ''
            var isready = showtime ? that.compareTIME(showtime) : true
            if (params.row.state == 0) {
              _tuisong = true
            } else {
              if (!isready) {
                _tuisong = true
              } else {
                _tuisong = false
              }
            }

            return h('div', [
              h('Dropdown', {
                props: {
                  trigger: "click"
                },
                on: {
                  'on-click': (value) => {
                    ////console.log(value) //此处的value和下面DropdownMenu选项的name对应
                    if (value == 'submit') {
                      this.formItem = JSON.parse(JSON.stringify(this.initformItem))
                      this.edit = true
                      this.curItem = params.row
                      this.getItemById(params.row.guid)
                    } else if (value == 'revise') {
                      this.showNewsModal = true
                      let opts = {
                        errorCorrectionLevel: "H", //容错级别
                        type: "image/png", //生成的二维码类型
                        quality: 0.3, //二维码质量
                        margin: 3, //二维码留白边距
                        width: 90, //宽
                        height: 90, //高
                        color: {
                          dark: "#333333", //前景色
                          light: "#fff" //背景色
                        }
                      };

                      // 将获取到的数据（val）画到msg（canvas）上

                      this.curNews.title = params.row.title
                      var _num = Math.random()
                      ////console.log(_num,'num')
                      _num = Math.floor(_num * 10000)
                      ////console.log(this.baseURL.weburl)
                      this.curNews.url = 'https://jlch.lebochelian.com/shareweb.html?timestamp=' + _num + '&id=' + params.row.guid
                      let msg = document.getElementById("QRCode_header");
                      QRCode.toCanvas(msg, this.curNews.url, opts, function (error) { })
                    } else if (value == 'delete') {
                      if (params.row.state == 0) {
                        this.$Modal.confirm({
                          title: '提示',
                          content: '<p>是否发布此条新闻？</p>',
                          onOk: () => {
                            that.axios.post('news/updateNewsState', {
                              id: params.row.guid,
                              state: 1
                            }).then(res => {
                              ////console.log(res)
                              that.$Message.success(res.msg)

                              that.reloadTable()


                            })
                          },
                          onCancel: () => {

                          }
                        });


                      } else {
                        this.$Modal.confirm({
                          title: '提示',
                          content: '<p>是否下架此条新闻？</p>',
                          onOk: () => {
                            that.axios.post('news/updateNewsState', {
                              id: params.row.guid,
                              state: 0
                            }).then(res => {

                              that.$Message.success(res.msg)
                              that.reloadTable()
                            }).catch(function (res) {
                              that.$Message.error('系统异常')
                            })
                          },
                          onCancel: () => {

                          }
                        });
                      }


                    }
                  }
                }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '60px',
                    height: '25px',
                    background: '#2db7f5',
                    borderRadius: '6px',
                    textAlign: 'center',
                    lineHeight: '25px',
                    color: '#fff',
                    fontSize: '12px',
                    cursor: 'pointer',
                    userSelect: 'none'
                  }
                }, [
                  h('span', '操作'),
                  h('Icon', {
                    props: {
                      type: 'md-arrow-dropdown'
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, [
                  h('DropdownItem', {
                    props: {
                      name: 'submit'
                    }
                  }, '编辑'),
                  h('DropdownItem', {
                    props: {
                      name: 'revise'
                    }
                  }, '预览'),
                  h('DropdownItem', {
                    props: {
                      name: 'delete'
                    }
                  }, _state)
                ])
              ])
            ])



          }
        }

        ]
      ],
      searchParam: {
        fid: '',
        title: '',
        itemid: '',
        rootid: 'news',
        pageno: -1,
        iswjno: 1,
      },
      pdData: [],
      curItem: {},
      issearch: -1,
      conImgList: [],
      clipboarde: '',
      denum: 0,
      pdData2: [],
      pdData3: [],
      btntype: 0, // 资源库 图片,
      addtings: {
        url: '',
        filetype: 0,
      },
      hadposter: 0,
      hadposterurl: '',
      upurl: '',
      selectList: [],
      selectzylist: [],
      olditemid: '',
      lbMadel: false,
      upurl2: 'http://180.103.125.157:9987/UploadImageServlet', //轮播图url
      lblist: [],
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    this.initformItem = JSON.parse(JSON.stringify(this.formItem))
    this.getpdData(0, 0)
    this.clipboarde = new this.clipboard("#copyLink");
    this.actionUrl = this.upurl = this.baseURL.imgURL
    this.getGwList(1)
    // this.postNewsMock()  //批量
  },
  methods: {
    upfileMethod () {

    },
    getallsort () {
      this.lblist = this.lblist.sort(function (a, b) {
        return a.sort - b.sort
      })
    },
    selectZy (e) {
      console.log(e)
      this.selectzylist = e
    },
    lookDetails (data) {
      this.$bus.$emit('newslistStore', data)
    },
    removeAll () {

      var datalist = this.selectList
      var that = this
      var arr = []
      datalist.map(function (val, index) {
        arr.push(val['guid'])
      })
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否删除选中的' + this.selectList.length + '条新闻？</p>',
        onOk: () => {
          arr.map(function (val, index) {
            var param = {
              id: val,
            }

            that.axios.post('news/delete', param).then(res => {
              ////console.log(res)
              if (index == arr.length - 1) {
                that.$Message.success(res.msg)
                that.reloadTable()
                that.selectList = []
              }



            }).catch(function (res) {
              that.$Message.error('未知问题')
            })
          })

        },
        onCancel: () => {

        }
      })
    },
    selectLcd (a) {

      this.selectList = a
    },
    beforeload (a, b, c) {
      var deferred = $.Deferred();
      var that = this
      var _url = a.name.split('.')
      var newurl = _url[_url.length - 1]
      var filetype = getfiletype(newurl)
      if (filetype == 0) {
        this.upurl = 'http://180.103.125.157:9987/UploadImageServlet'
        if (this.picwater == '0') {
          that.upurl += '&iswater=1'
        }
      } else {
        this.upurl = this.baseURL.imgURL
      }
      this.$nextTick(() => {
        deferred.resolve();
      });
      return deferred
      function getfiletype (ext) {
        if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
          return 0
        } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
          return 2
        } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
          return 1
        } else {
          return 4
        }

      }
    },
    getfiletype (ext) {
      if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
        return 0
      } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
        return 2
      } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
        return 1
      } else {
        return 4
      }

    },
    beforeload (a, b, c) {
      return new Promise((resolve) => {
        const ext = a.name.split('.').pop().toLowerCase();
        const filetype = this.getFileType(ext);

        if (filetype === 0) {
          this.upurl = 'http://180.103.125.157:9987/UploadImageServlet';
          if (this.picwater === '0') {
            this.upurl += '&iswater=1';
          }
        } else {
          this.upurl = this.baseURL.imgURL;
        }

        this.$nextTick(() => {
          resolve(true);
        });
      });
    },
    beforeload (a, b, c) {
      const ext = a.name.split('.').pop().toLowerCase();
      const filetype = this.getfiletype(ext);

      if (filetype === 0) {
        this.upurl = 'http://180.103.125.157:9987/UploadImageServlet';
        if (this.picwater === '0') {
          this.upurl += '&iswater=1';
        }
      } else {
        this.upurl = this.baseURL.imgURL;
      }

      return true;
    },
    changepicwater (e) {
      this.picwater = String(e)
    },
    dsgetCurtime () {
      var curtime = this.getcurTime()
      this.$set(this.formItem, 'pubtime', curtime)
    },
    fileSUccess (a, b, c) {
      var _url = a.url.split('.')
      var newurl = _url[_url.length - 1]
      var tupian = getfiletype(newurl)
      this.hadposter = tupian
      function getfiletype (ext) {
        if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
          return 0
        } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
          return 2
        } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
          return 1
        } else {
          return 4
        }
      }
      if (tupian != 2) {
        this.disbtn = false
      } else {
        this.hadposterurl = a.url
      }

    },
    fileSUccess3 (a, b, c) {
      console.log(a, b, c, 'abc')
      var _url = a.url.split('.')
      var newurl = _url[_url.length - 1]
      var tupian = getfiletype(newurl)

      function getfiletype (ext) {
        if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
          return 0
        } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
          return 2
        } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
          return 1
        } else {
          return 4
        }
      }
      this.formItem.thum = a.url
    },
    fileSUccess2 (a, b, c) {
      console.log(a, b, c)
      this.lblist.push({ url: a['url'], sort: this.lblist.length })
    },
    clicktool (tool) {
      ////console.log(tool)
      if (tool == '0') {
        this.choseSource = '0'
        this.newGWMadel = true
        this.newGWData.url = ''
        if (this.$refs.upload) {
          this.$refs.upload.fileList = []
        }
      } else {
        this.lbMadel = true
      }


    },
    changeSource (e) {

      if (e == 2) {
        this.btntype = 1
        this.assestModal = true
        this.changeAssType()
        this.newGWMadel = false;
      }
      this.disbtn = e == 1 ? false : true

    },
    transBase64FromImage (image) {
      let canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0, image.width, image.height)
      // 可选其他值 image/jpeg

      return canvas.toDataURL('image/jpeg')
    },
    // 设置需要展示的图片  base64
    setImgBase64 (src, callback) {
      let _this = this
      let image = new Image()
      // 处理缓存
      src = src.split("?")[0]
      image.src = src + '?v=' + Math.random()
      // 支持跨域图片
      image.crossOrigin = '*'
      image.onload = function () {
        let base64 = _this.transBase64FromImage(image)
        callback && callback(base64)
      }
    },
    getBase64Img (params) {
      if (params && params.url) {
        var that = this;
        var image = new Image();
        image.src = params.url + "?" + Math.random();
        image.crossOrigin = 'anonymous';
        image.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0, image.width, image.height);
          var ext = image.src.substring(image.src.lastIndexOf(".") + 1).toLowerCase();
          var dataURL = canvas.toDataURL("image/" + ext);
          if (params.callback) {
            if (params.data) {
              that[params.callback](dataURL, params.data);
            } else {
              that[params.callback](dataURL);
            }
          };
          return dataURL;
        }
      }
    },
    postNewGW () {
      var that = this
      if (this.choseSource == '0') {
        var uploadlist = this.$refs.upload.fileList
        console.log(uploadlist, 'uploadlet')
        if (uploadlist.length > 0) {
          var filelist = uploadlist
          var pic = []
          filelist.map(function (val, index) {
            // pic += val['response']['url']
            pic.push(val['response']['url'])
          })
          this.newGWData.url = pic.join(',')

        } else {
          this.$Message.warning('请上传资源')
          return false;
        }
        if (that.newGWData.url.indexOf('mp4') > -1) {
          var url = that.newGWData.url.split('.mp4')
          that.newGWData.url = url[1] + '&' + url[0] + '.mp4'
        }
        if (that.newGWData.url.indexOf('m4v') > -1) {
          var url = that.newGWData.url.split('.m4v')
          that.newGWData.url = url[1] + '&' + url[0] + '.m4v'
        }
      }

      if (that.newGWData.url == '') {
        this.$Message.warning('网络地址不能为空')
        return false
      }

      // var _url = that.newGWData.url.split('.')
      var _url = that.newGWData.url.split('.')
      var newurl = _url[_url.length - 1]
      var tupian = getfiletype(newurl)
      // if(this.upadtetoself){
      var param = {
        url: that.newGWData.url,
        filetype: tupian,
        ispublic: '0',
        filename: '新闻内容'
      }


      this.axios.post('media/save', param).then(res => {
        ////console.log(res)
        that.disbtn = true
      })
      // }
      that.addtings = {
        url: that.newGWData.url,
        name: that.newGWData.name,
        filetype: tupian
      }
      that.addtings.filetype = tupian
      that.newGWMadel = false;
      that.choseSource = '0',
        console.log(that.addtings)
      that.newGWData = {
        url: '',
      }

      function getfiletype (ext) {
        if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
          return 0
        } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
          return 2
        } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
          return 1
        } else {
          return 4
        }

      }

    },
    postlb () {
      this.addtings = {
        url: this.lblist,
        filetype: '6'
      }
      this.lbMadel = false
    },
    getfiletype (ext) {
      if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
        return 0
      } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
        return 2
      } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
        return 1
      } else {
        return 4
      }

    },
    rowData (a) {  // 资源库文件 

      var that = this
      var picStr = []
      var checkImglist = [a]
      if (this.btntype == 0) { // 封面图片选择 资源库
        // assestType

        checkImglist.map(function (val, index) {
          if (val['poster']) {
            picStr.push(val['poster'] + '&' + val['url'])
          } else {
            picStr.push(val['url'])
          }

        })
        if (that.formItem.thum == '') {
          that.formItem.thum = picStr.join(',')
        } else {
          var str = picStr.join(',')
          that.formItem.thum = that.formItem.thum + ',' + str
        }


      } else if (this.btntype == 1) {


        checkImglist.map(function (val, index) {
          if (val['poster']) {
            picStr.push(val['poster'] + '&' + val['url'])
          } else {
            picStr.push(val['url'])
          }

        })
        that.addtings = {
          filetype: that.assestType,
          url: picStr.join(',')
        }


      } else if (this.btntype == 2) { // 封面图片选择 资源库
        // assestType

        checkImglist.map(function (val, index) {
          if (val['poster']) {
            picStr.push(val['poster'] + '&' + val['url'])
          } else {
            picStr.push(val['url'])
          }

        })
        if (that.formItem.pic1 == '') {
          that.formItem.pic1 = picStr.join(',')
        } else {
          var str = picStr.join(',')
          that.formItem.pic1 = that.formItem.pic1 + ',' + str
        }


      } else if (this.btntype == 3) { // 封面图片选择 资源库
        // assestType

        checkImglist.map(function (val, index) {
          if (val['poster']) {
            picStr.push(val['poster'] + '&' + val['url'])
          } else {
            picStr.push(val['url'])
          }

        })
        if (that.formItem.pic2 == '') {
          that.formItem.pic2 = picStr.join(',')
        } else {
          var str = picStr.join(',')
          that.formItem.pic2 = that.formItem.pic2 + ',' + str
        }


      }
      that.assestModal = false
    },
    postImg () {
      var that = this
      var picStr = []
      if (this.btntype == 0) { // 封面图片选择 资源库
        // assestType

        var checkImglist = that.selectzylist
        checkImglist.map(function (val, index) {
          if (val['poster']) {
            picStr.push(val['poster'] + '&' + val['url'])
          } else {
            picStr.push(val['url'])
          }

        })
        if (that.formItem.thum == '') {
          that.formItem.thum = picStr.join(',')
        } else {
          var str = picStr.join(',')
          that.formItem.thum = that.formItem.thum + ',' + str
        }




      } else if (this.btntype == 1) {

        var checkImglist = that.selectzylist
        checkImglist.map(function (val, index) {
          if (val['poster']) {
            picStr.push(val['poster'] + '&' + val['url'])
          } else {
            picStr.push(val['url'])
          }

        })
        that.addtings = {
          filetype: that.assestType,
          url: picStr.join(',')
        }


      }
      that.assestModal = false
    },
    changeAssType (e) {
      ////console.log(e)
      var that = this
      that.gwlist.map(function (val, index) {
        val['ischeck'] = false
      })
      that.gwlisted.map(function (val, index) {
        val['ischeck'] = false
      })
    },
    getfromAssest (type) {
      this.btntype = type
      this.assestType = '0'
      this.assestModal = true
      this.changeAssType()
    },
    checkItem (item, index, type) {
      ////console.log(item,index)
      if (type == 0) {
        var _ischeck = this.gwlist[index]['ischeck']
        this.gwlist[index]['ischeck'] = !_ischeck
      } else {
        var _ischeck = this.gwlisted[index]['ischeck']
        this.gwlisted[index]['ischeck'] = !_ischeck
      }


    },
    switchFileType (name) {


      if (name == 'weiyue') {
        this.newGWData.ispublic = '0'
        this.searchzyParam.ispublic = '0'
        this.issearchzy = Math.random()

      } else if (name == 'yiyue') {
        this.newGWData.ispublic = '1'
        this.searchzyParam.ispublic = '1'
        this.issearchzy = Math.random()

      } else {
        this.issearchzy = Math.random()

      }
    },
    switchFileType (name) {
      ////console.log(name,name=='weiyue',name=='yiyue')
      this.pageno = 1
      this.listtabname = name
      this.couldScroll = true
      if (name == 'weiyue') {
        this.getGwList()
      } else if (name == 'yiyue') {
        this.getGwList(1)
      } else {
        this.getSelfGW()
      }
    },
    getGwList (type, param) {
      var that = this
      var params = {
        pageno: that.pageno,
        ispublic: type ? type : 0,
        length: 100,
      }
      if (param) {
        params['begintime'] = param['begintime']
        params['endtime'] = param['endtime']
        params['pageno'] = that.pageno = 1
      }
      this.axios.get('media/getQueryList', {
        params: params
      }).then(back => {
        var res = back.data
        res.map(function (val, index) {
          val['ischeck'] = false
          if (val['filetype'] == 2) {
            var _url = val['url']
            if (_url.indexOf('&') > -1) {
              val['url'] = _url.split('&')[1]
              val['poster'] = _url.split('&')[0]
            }

          }
        })
        if (res.length == 0) {
          that.$Message.warning('数据加载完毕')
          if (type == 0) {
            if (that.pageno == 1) {
              that.gwlist = []
            }
          } else if (type == 1) {
            if (that.pageno == 1) {
              that.gwlisted = []
            }
          }
          return false;
        }
        if (type) {
          if (that.pageno != 1) {
            that.gwlisted = that.gwlisted.concat(res)
          } else {
            that.gwlisted = res
          }

        } else {

          if (that.pageno != 1) {
            that.gwlist = that.gwlist.concat(res)
          } else {
            that.gwlist = res
          }

        }

      })
    },
    copyLink () {
      let _this = this;

      this.clipboarde.on('success', function (e) {
        _this.denum++

        if (_this.denum == 1) {
          _this.$Message.info("复制成功!")
          setTimeout(function () {
            _this.denum = 0
          }, 2000)
        }

      });
      this.clipboarde.on('error', function () {
        _this.$Message.error("复制失败!")
      });


    },
    setUrl (item, index) {


      var that = this
      var autowidth = ''
      var autoheight = ''
      if (that.formItem.showtype == 1 || that.formItem.showtype == 2) {

        autowidth = 330
        autoheight = 216
      } else if (that.formItem.showtype == 3) {
        autowidth = 686
        autoheight = 160

      } else if (that.formItem.showtype == 4 || that.formItem.showtype == 5) {
        autowidth = 686
        autoheight = 386

      }

      if (this.btntype == 2) {
        autowidth = 750
        autoheight = 420
      } else if (this.btntype == 3) {
        autowidth = 610
        autoheight = 864
      }
      console.log(autowidth, autoheight)
      ////console.log(that.formItem.showtype,autowidth,autoheight,item)
      this.curImgIndex = index
      var _imgs = ''

      this.setImgBase64(item, function (img) {

        that.$nextTick(() => {
          that.example2 = {
            img: img,
            info: true,
            size: 1,
            outputType: 'jpeg',
            canScale: false,
            canMove: false,
            autoCrop: true,
            // 只有自动截图开启 宽度高度才生效
            autoCropWidth: autowidth,
            autoCropHeight: autoheight,
            // width: autowidth, // 输出画布的目标宽度
            // height: autoheight, // 输出画布的目标高度。
            // minWidth: autowidth, // 输出画布的最小目标宽度，默认值为0。
            // minHeight: autoheight, // 输出画布的最小目标高度，默认值为0。
            // maxWidth: autowidth, // 输出画布的最大目标宽度，默认值为Infinity(无穷大)。
            // maxHeight: autoheight// 输出画布的最大目标高度，默认值为Infinity(无穷大)。
            maxImgSize: 1000,
            fixed: true,
            fixedNumber: [autowidth, autoheight]
          }

        })

      })


    },
    tabPD (index, item, lv) {

      localStorage.setItem('curItemid', item.guid)

      if (lv == 1) {
        this.curIndex = index
        this.pdData3 = []
        this.curIndex1 = 0
        this.searchParam.fid = item.guid
      } else if (lv == 2) {
        this.curIndex1 = index
        this.curIndex2 = 0
      } else if (lv == 3) {
        this.curIndex2 = index
      }
      this.searchParam.itemid = item.guid
      if (item.guid == '' && item.pid != '') {
        this.getpdData(item.guid, lv, item.pid)
      } else {
        this.getpdData(item.guid, lv)
      }
      ////console.log(index,item,lv)

    },
    getpdData (pid, lv, ppid) {
      var that = this
      ////console.log(pid,lv)

      var allData = {
        name: '全部',
        guid: '',

      }
      if (lv == 0) {
        var that = this
        this.axios.get('dic/getQueryList', {
          params: {
            rootid: 'news',
            pid: 0,
            length: -1
          }
        }).then(res => {

          var allData = {
            name: '全部',
            guid: '',
          }
          res.data.unshift(allData)
          that.pdData = res.data.filter(function (val, index) {
            return val['guid'] != '8888'
          })
        })
      } else if (lv == 1) {
        if (pid == '') {
          this.pdData2 = []
          this.searchParam.itemid = ''
        } else {
          that.getpdchildData(pid, 1)
        }
        this.searchData()
      } else if (lv == 2) {
        if (pid == '') {
          this.pdData3 = []
          this.searchParam.itemid = ppid
        } else {
          that.getpdchildData(pid)
        }
        this.searchData()
      } else if (lv == 3) {
        if (pid == '') {
          this.searchParam.itemid = ppid
        }
        this.searchData()
      }

    },
    getpdchildData (pid, lv) {
      var that = this
      this.axios.get('dic/getQueryList', {
        params: {
          rootid: 'news',
          pid: pid,
          length: -1
        }
      }).then(res => {
        ////console.log(res)
        if (res.data.length > 0) {
          var allData = {
            name: '全部',
            guid: '',
            pid: pid
          }
          res.data.unshift(allData)
        }

        if (lv == 1) {
          that.pdData2 = res.data

        } else {
          that.pdData3 = res.data
        }
      })
    },
    finish2old () {
      var that = this
      //获取base64
      //  this.$refs.cropper.getCropData(data => {
      // 链接已复制
      //    ////console.log(data)
      //  })
      this.$refs.cropper2.getCropBlob((imgData) => {

        console.log(imgData, 'data2')

        // this.modelSrc = data
        // this.model = false;
        // this.example2.img = this.modelSrc;
        var data = new FormData()

        data.append('file', imgData, Date.parse(new Date()) + ".png");
        var wihei = ''
        if (that.formItem.showtype == 1 || that.formItem.showtype == 2) {
          wihei = 'maxW=330&maxH=216'
        } else if (that.formItem.showtype == 3) {
          wihei = 'maxW=686&maxH=160'
        } else if (that.formItem.showtype == 4 || that.formItem.showtype == 5) {
          wihei = 'maxW=686&maxH=386'
        }

        if (that.btntype == 2) {
          wihei = 'maxW=750&maxH=420'
        } else if (that.btntype == 3) {
          wihei = 'maxW=610&maxH=864'
        }
        $.ajax({
          method: "post",
          url: that.actionUrl + '?ispress=1&iscopy=1&notkeeppic=1&' + wihei,
          data: data,
          processData: false,
          contentType: false,
          success: function (result) {
            console.log(result)
            if (that.btntype == 2) {
              var _thum = that.formItem.pic1
              if (_thum) {
                that.$set(that.formItem, 'pic1', _thum + ',' + result.url)
              } else {
                that.$set(that.formItem, 'pic1', result.url)
              }
              that.showpicModal = false
            } else if (that.btntype == 3) {
              var _thum = that.formItem.pic2
              if (_thum) {
                that.$set(that.formItem, 'pic2', _thum + ',' + result.url)
              } else {
                that.$set(that.formItem, 'pic2', result.url)
              }
              that.showpicModal2 = false
            } else {
              var _thum = that.formItem.thum
              if (_thum) {
                that.$set(that.formItem, 'thum', _thum + ',' + result.url)
              } else {
                that.$set(that.formItem, 'thum', result.url)
              }
            }

            that.$Message.info('裁剪成功')
          }
        });


        //阿里云处理图片，项目的接口，这里可以不用，上面的地址打印即为base64的地址

      })

    },
    finish3old () {
      var that = this
      //获取base64
      //  this.$refs.cropper.getCropData(data => {
      // 链接已复制
      //    ////console.log(data)
      //  })
      this.$refs.cropper3.getCropBlob((imgData) => {

        ////console.log(imgData,'data2')

        // this.modelSrc = data
        // this.model = false;
        // this.example2.img = this.modelSrc;
        var data = new FormData()

        data.append('file', imgData, Date.parse(new Date()) + ".png");
        var wihei = ''
        if (that.formItem.showtype == 1 || that.formItem.showtype == 2) {
          wihei = 'maxW=330&maxH=216'
        } else if (that.formItem.showtype == 3) {
          wihei = 'maxW=686&maxH=160'
        } else if (that.formItem.showtype == 4 || that.formItem.showtype == 5) {
          wihei = 'maxW=686&maxH=386'
        }

        if (that.btntype == 2) {
          wihei = 'maxW=750&maxH=420'
        } else if (that.btntype == 3) {
          wihei = 'maxW=610&maxH=864'
        }
        console.log($, '$')
        $.ajax({
          method: "post",
          url: that.actionUrl + '?ispress=1&iscopy=1&notkeeppic=1&' + wihei,
          // url: that.actionUrl + '?ispress=1&iscopy=1&notkeeppic=&' + wihei,
          data: data,
          processData: false,
          contentType: false,
          success: function (result) {
            ////console.log(result)
            if (that.btntype == 2) {
              var _thum = that.formItem.pic1
              if (_thum) {
                that.$set(that.formItem, 'pic1', _thum + ',' + result.url)
              } else {
                that.$set(that.formItem, 'pic1', result.url)
              }
            } else if (that.btntype == 3) {
              var _thum = that.formItem.pic2
              if (_thum) {
                that.$set(that.formItem, 'pic2', _thum + ',' + result.url)
              } else {
                that.$set(that.formItem, 'pic2', result.url)
              }
            } else {
              var _thum = that.formItem.thum
              if (_thum) {
                that.$set(that.formItem, 'thum', _thum + ',' + result.url)
              } else {
                that.$set(that.formItem, 'thum', result.url)
              }
            }

            that.$Message.info('裁剪成功')
            that.showpicModal2 = false
          }
        });


        //阿里云处理图片，项目的接口，这里可以不用，上面的地址打印即为base64的地址

      })

    },
    finish2 () {
      var that = this
      this.$refs.cropper2.getCropData((imgData) => {

        var wihei = ''
        if (that.formItem.showtype == 1 || that.formItem.showtype == 2) {
          wihei = 'maxW=330&maxH=216'
        } else if (that.formItem.showtype == 3) {
          wihei = 'maxW=686&maxH=160'
        } else if (that.formItem.showtype == 4 || that.formItem.showtype == 5) {
          wihei = 'maxW=686&maxH=386'
        }

        if (that.btntype == 2) {
          wihei = 'maxW=750&maxH=420'
        } else if (that.btntype == 3) {
          wihei = 'maxW=610&maxH=864'
        }
        var _wihei = wihei.split("&")
        var targetWidth = _wihei[0].split('=')[1] // 设置目标宽度
        var targetHeight = _wihei[1].split('=')[1]; // 设置目标高度
        // 创建一个新的Image对象
        var img = new Image();
        img.src = imgData

        // 监听Image对象的加载完成事件
        img.onload = function () {

          // 创建一个Canvas元素
          var canvas = document.createElement('canvas');
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          // 获取2D绘图上下文
          var ctx = canvas.getContext('2d');

          // 在Canvas上绘制调整尺寸后的图片
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

          // 将Canvas上的内容转换为Blob对象
          canvas.toBlob(function (resizedBlob) {
            // 创建FormData对象
            var data = new FormData();
            // 将调整尺寸后的Blob对象添加到FormData中
            data.append('file', resizedBlob, Date.parse(new Date()) + ".png");
            $.ajax({
              method: "post",
              url: that.actionUrl + '?ispress=&iscopy=1&notkeeppic=&' + wihei,
              data: data,
              processData: false,
              contentType: false,
              success: function (result) {
                console.log(result)
                if (that.btntype == 2) {
                  var _thum = that.formItem.pic1
                  if (_thum) {
                    that.$set(that.formItem, 'pic1', _thum + ',' + result.url)
                  } else {
                    that.$set(that.formItem, 'pic1', result.url)
                  }
                  that.showpicModal = false
                } else if (that.btntype == 3) {
                  var _thum = that.formItem.pic2
                  if (_thum) {
                    that.$set(that.formItem, 'pic2', _thum + ',' + result.url)
                  } else {
                    that.$set(that.formItem, 'pic2', result.url)
                  }
                  that.showpicModal2 = false
                } else {
                  var _thum = that.formItem.thum
                  if (_thum) {
                    that.$set(that.formItem, 'thum', _thum + ',' + result.url)
                  } else {
                    that.$set(that.formItem, 'thum', result.url)
                  }
                }

                that.$Message.info('裁剪成功')

              }
            });

          }, 'image/png'); // 指定输出图片的MIME类型，这里假设为PNG格式
        };
        //阿里云处理图片，项目的接口，这里可以不用，上面的地址打印即为base64的地址

      })

    },
    finish3 () {
      var that = this
      this.$refs.cropper3.getCropData((imgData) => {
        var wihei = ''
        if (that.formItem.showtype == 1 || that.formItem.showtype == 2) {
          wihei = 'maxW=330&maxH=216'
        } else if (that.formItem.showtype == 3) {
          wihei = 'maxW=686&maxH=160'
        } else if (that.formItem.showtype == 4 || that.formItem.showtype == 5) {
          wihei = 'maxW=686&maxH=386'
        }

        if (that.btntype == 2) {
          wihei = 'maxW=750&maxH=420'
        } else if (that.btntype == 3) {
          wihei = 'maxW=610&maxH=864'
        }
        var _wihei = wihei.split("&")
        var targetWidth = _wihei[0].split('=')[1] // 设置目标宽度
        var targetHeight = _wihei[1].split('=')[1]; // 设置目标高度
        // 创建一个新的Image对象
        var img = new Image();
        img.src = imgData

        // 监听Image对象的加载完成事件
        img.onload = function () {

          // 创建一个Canvas元素
          var canvas = document.createElement('canvas');
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          // 获取2D绘图上下文
          var ctx = canvas.getContext('2d');

          // 在Canvas上绘制调整尺寸后的图片
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

          // 将Canvas上的内容转换为Blob对象
          canvas.toBlob(function (resizedBlob) {
            // 创建FormData对象
            var data = new FormData();
            // 将调整尺寸后的Blob对象添加到FormData中
            data.append('file', resizedBlob, Date.parse(new Date()) + ".png");
            $.ajax({
              method: "post",
              url: that.actionUrl + '?ispress=&iscopy=1&notkeeppic=&' + wihei,
              // url: that.actionUrl + '?ispress=1&iscopy=1&notkeeppic=&' + wihei,
              data: data,
              processData: false,
              contentType: false,
              success: function (result) {
                if (that.btntype == 2) {
                  var _thum = that.formItem.pic1
                  if (_thum) {
                    that.$set(that.formItem, 'pic1', _thum + ',' + result.url)
                  } else {
                    that.$set(that.formItem, 'pic1', result.url)
                  }
                } else if (that.btntype == 3) {
                  var _thum = that.formItem.pic2
                  if (_thum) {
                    that.$set(that.formItem, 'pic2', _thum + ',' + result.url)
                  } else {
                    that.$set(that.formItem, 'pic2', result.url)
                  }
                } else {
                  var _thum = that.formItem.thum
                  if (_thum) {
                    that.$set(that.formItem, 'thum', _thum + ',' + result.url)
                  } else {
                    that.$set(that.formItem, 'thum', result.url)
                  }
                }

                that.$Message.info('裁剪成功')
                that.showpicModal2 = false
              }
            });
            // 在这里可以使用data进行上传操作
          }, 'image/png'); // 指定输出图片的MIME类型，这里假设为PNG格式
        };

      })

    },
    finish4 () {
      var that = this
      ////console.log(this.$refs.cropper2)
      //获取base64
      //  this.$refs.cropper.getCropData(data => {

      //    ////console.log(data)
      //  })
      this.$refs.cropper2.getCropBlob((imgData) => {
        //  this.$refs.cropper2("getCroppedCanvas",{ width: 500, height: 500}).toBlob(function(blob){


        // this.modelSrc = data
        // this.model = false;
        // this.example2.img = this.modelSrc;


        var data = new FormData()

        data.append('file', imgData, Date.parse(new Date()) + ".png");


        $.ajax({
          method: "post",
          url: that.actionUrl,
          data: data,

          processData: false,
          contentType: false,
          success: function (result) {
            ////console.log(result)
            var _thum = that.formItem.thum
            that.$set(that.formItem, 'thum', _thum + ',' + result.url)
          }
        });


        //阿里云处理图片，项目的接口，这里可以不用，上面的地址打印即为base64的地址

      })

    },
    rendom () {
      return
    },

    getConImg (type) {
      // var reg = /(\/|^src=['"]?http)[^>]+\.(jpg|jpeg|png|gif)/g;
      this.btntype = type
      var reg = /src=[\'\"]?([^\'\"]*)[\'\"]?/gi
      var _igm = this.editContent.match(reg)
      var newarr = []
      _igm.map(function (val, index) {
        var _src = val.slice(5, val.length - 1)
        ////console.log(_src)
        newarr.push(_src)
      })
      this.conImgList = newarr
      if (type == 3) {
        this.showpicModal2 = true
      } else {
        this.showpicModal = true
      }

      this.setUrl(newarr[0], 0)
      ////console.log(newarr[0],0)
      ////console.log(newarr)
    },
    upVideo (a, b, c) {


      //this.$refs['videoUpload'][0].clearFiles()

      this.$set(this.formItem, 'videourl', a.url)
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '请选择mp4格式文件'
      });
    },
    tabPD3 (index, item) {

      this.curIndex = index
      this.searchParam.itemid = item.guid
      this.searchData()
    },
    getpdData2 () {
      var that = this
      this.axios.get('dic/getQueryList', {
        params: {
          rootid: 'news',
          pid: 0,
          length: -1,
        }
      }).then(res => {

        var allData = {
          name: '全部',
          guid: '',
        }
        res.data.unshift(allData)
        that.pdData = res.data
      })
    },
    getDateData (a, b) {
      this.searchParam.begintime = a[0]
      this.searchParam.endtime = a[1]
    },
    editorContent (val) {

      this.editContent = val
    },
    changeRenke (val) {
      this.formItem.itemid = val['classid'].split(',')
    },
    hideInput (e) {

      this.hideInputNum = Math.random()
    },
    postNews (iscg) {

      var picstr = []
      // if(this.storeimg.length>0){
      //   var storeimg = this.storeimg[0]['children']
      //   storeimg.map(function(val, index) {
      //     picstr.push(val['picsmall'])
      //   })
      //   picstr = picstr.concat(this.formItem.thum.split(','))
      // }else{
      picstr = this.formItem.thum.split(',')
      // }
      ////console.log(this.storeimg,this.formItem.thum)

      //海报图片宽 

      //海报图片高


      var that = this
      var paramData = JSON.parse(JSON.stringify(this.formItem))


      var param = {}
      ////console.log(paramData.itemid,'paramData')
      ////console.log(this.renderTime(paramData['showtime']), this.renderTime(paramData['pubtime']))
      ////console.log(paramData['editor'])
      var newSorts = new Array(paramData.itemid.length)
      // param['topshow'] = paramData.topshow ? 1 : 0

      param['istop'] = paramData.istop ? 1 : 0
      param['itemid'] = paramData.itemid.join(',')
      param['title'] = paramData['title']
      param['content'] = this.editContent
      param['url'] = paramData['url'] || ''
      param['videourl'] = paramData['videourl'] || ''
      param['owner'] = paramData['owner'] == '' ? paramData['owner'] : paramData['owner'].replace('/\s/g', '，')
      param['source'] = paramData['source']
      param['showtime'] = this.renderTime(paramData['showtime'])
      // param['departid']  =  paramData['departid'] || ''
      // param['topic']  =  paramData['topic'] || ''
      param['detialtitle'] = paramData['detialtitle']
      param['auther'] = paramData['auther']
      param['editor'] = paramData['editor'] == '' ? paramData['editor'] : paramData['editor'].replace('/\s/g', '，')
      param['linktype'] = paramData['linktype']
      param['showtype'] = paramData['showtype']
      param['thum'] = picstr.join(',')
      param['pic1'] = paramData['pic1']
      param['pic2'] = paramData['pic2']
      param['summary'] = paramData['summary']
      param['keyword'] = paramData['keyword']
      param['pubtime'] = that.renderTime(paramData['pubtime'])
      if (!this.ordertime) {
        param['showtime'] = that.renderTime(paramData['pubtime'])
      }

      param['vewcnt'] = paramData['vewcnt']
      param['isinsideadv'] = paramData['isinsideadv'] ? 1 : 0
      param['enableComment'] = paramData['enableComment'] ? 1 : 0
      param['enablelike'] = paramData['enablelike'] ? 1 : 0
      param['isoriginal'] = paramData['isoriginal'] ? 1 : 0

      param['ispush'] = paramData['ispush']
      param['guid'] = paramData['guid']
      param['olditemid'] = that.olditemid
      if (param['itemid'] == '') {
        that.$Message.info('请选择所属栏目')
        return false
      }
      if (param['title'] == '') {
        that.$Message.info('请补充标题')
        return false
      }
      if (that.showtype == 1 && param['thum'] == '') {
        that.$Message.info('请上传封面图片')
        return false
      }
      if (param['source'] == '') {
        param['source'] = '太湖新城楼宇会'
      }

      if (!param['guid']) {
        param['state'] = 0
      } else {
        param['state'] = paramData['state'] ? 1 : 0
      }
      param['isapp'] = 0
      param['isweb'] = 0
      // if(this.mewsto.length>0){
      //    this.mewsto.map(function(val,index){
      //         param[val] = 1
      //    })
      // }
      if (param['guid'] == '') {
        param['sorts'] = newSorts.join(',')
      } else {
        var lanmuid = paramData.itemid
        var dataitem = paramData['itemList']
        var sortdata = new Array(lanmuid.length).fill('emp')
        ////console.log(lanmuid,dataitem)


        lanmuid.map(function (val, index) {
          dataitem.some(function (dval, dindex) {
            var _itemidData = dval['itemid'].split('_')
            var _itemid = _itemidData[_itemidData.length - 1]

            var _valdata = val.split('_')
            var _valid = _valdata[_valdata.length - 1]
            if (_valid == _itemid) {
              sortdata.splice(index, 1, dval['sort'])
            }
          })
        })

        sortdata = sortdata.join(',')
        sortdata = sortdata.replace(/emp/g, '')
        param['sorts'] = sortdata
        param['itemList'] = dataitem
      }

      //console.log(param,'param')
      var newslist = localStorage.getItem('jwjNews')
      // console.log(newslist)
      newslist = newslist ? JSON.parse(newslist) : []
      if (newslist.length < 5) {
        newslist.push(param)
      } else {
        newslist.pop()
        newslist.unshift(param)
      }
      localStorage.setItem('jwjNews', JSON.stringify(newslist))

      that.$emit('refreshnews', newslist)
      delete param['itemList']
      that.axios.post('news/save', param).then(function (res, back) {
        // console.log(res, back, 'res')
        if (res.success) {
          if (param['guid']) {
            that.axios.post('news/updateNewsState', { id: param['guid'], state: param['state'] }).then(function (res, back) {
              that.$Message.info('新闻更新成功')
            })
          } else {
            that.$Message.success('新闻发布成功')
          }
          that.edit = false
          that.reloadTable()
        }
      }).catch(function (err) {
        // console.log(err)
        that.axios.post('news/save', param).then(function (res, back) {
          if (res.success) {
            if (param['guid']) {
              that.axios.post('news/updateNewsState', { id: param['guid'], state: param['state'] }).then(function (res, back) {
                that.$Message.info('新闻更新成功')
              })
            } else {
              that.$Message.success('新闻发布成功')
            }
            that.edit = false
            that.reloadTable()
          }

        }).catch(function (err) {
          that.$Message.error('保存失败，请联系技术人员')
        })

      })
    },
    postNewsMock () {
      var that = this
      var arr = []
      arr.map(function (val, index) {
        that.axios.post('news/save', val).then(function (res, back) {
          console.log(res, back, 'res')
        }).catch(function (err) {

        })
      })

    },
    getItemById (id) {
      // that.formItem = JSON.parse(JSON.stringify(this.initformItem))
      var that = this
      that.axios.get('news/getId', {
        params: {
          id: id,
        }
      }).then(res => {
        ////console.log(res)
        that.treekey = Math.random()
        if (res.data) {
          var _data = res.data
          _data['state'] = _data['state'] == 1 ? true : false
          _data['istop'] = _data['istop'] == 1 ? true : false

          // _data['topshow'] = _data['topshow'] == 1 ? true : false
          _data['isinsideadv'] = _data['isinsideadv'] == 1 ? true : false
          _data['enableComment'] = _data['enableComment'] == 1 ? true : false
          _data['enablelike'] = _data['enablelike'] == 1 ? true : false
          _data['isoriginal'] = _data['isoriginal'] == 1 ? true : false
          _data['showtype'] = String(_data['showtype'])
          _data['pic1'] = _data['pic1'] ? _data['pic1'] : ''
          _data['pic2'] = _data['pic2'] ? _data['pic2'] : ''
          that.olditemid = _data['itemid']
          if (_data['showtime'] == _data['pubtime']) {
            this.ordertime = false
          } else {
            this.ordertime = true
          }
          var itemid = _data['itemid'].split(',')
          ////console.log(itemid)
          var lanmu = []
          itemid.map(function (val, index) {
            var _val = val.split('_')
            lanmu.push(_val[_val.length - 1])
          })
          that.lanmu = lanmu
          _data['itemid'] = _data['itemid'].split(',')
          _data['linktype'] = String(_data['linktype'])
          if (_data['showtime'] == _data['pubtime']) {

            // that.$set(that,'ordertime',false)

            that.ordertime = false
          } else {
            // that.$set(that,'ordertime',true)
            that.ordertime = true

          }

          that.$set(that, 'formItem', _data)
        }
      })
    },
    getItemByData (idx) {
      this.edit = true
      var that = this
      var _data = JSON.parse(localStorage.getItem('jwjNews'))

      _data = _data[idx]
      that.treekey = Math.random()


      _data['state'] = _data['state'] == 1 ? true : false
      _data['istop'] = _data['istop'] == 1 ? true : false


      _data['isinsideadv'] = _data['isinsideadv'] == 1 ? true : false
      _data['enableComment'] = _data['enableComment'] == 1 ? true : false
      _data['enablelike'] = _data['enablelike'] == 1 ? true : false
      _data['isoriginal'] = _data['isoriginal'] == 1 ? true : false

      _data['showtype'] = String(_data['showtype'])


      if (_data['showtime'] == _data['pubtime']) {
        this.ordertime = false
      } else {
        this.ordertime = true
      }


      var itemid = _data['itemid'].split(',')

      var lanmu = []
      itemid.map(function (val, index) {
        var _val = val.split('_')
        lanmu.push(_val[_val.length - 1])
      })

      that.lanmu = lanmu
      _data['itemid'] = _data['itemid'].split(',')

      _data['linktype'] = String(_data['linktype'])
      if (_data['showtime'] == _data['pubtime']) {



        that.ordertime = false
      } else {

        that.ordertime = true

      }

      that.$set(that, 'formItem', _data)


    },
    upImglist (a, b, c) {
      ////console.log(a, b, c)
      var that = this
      that.btntype = 1
      var _name = a.name
      var pics = a.pics
      var arr = []
      var clipArr = []
      for (var i = 0; i < pics.length; i++) {
        var item = pics[i]['response']['url']
        var pic = item.split("@")[1]
        var picsmall = item.split("@")[0]
        var obj = {
          pic: pic,
          picsmall: picsmall,
        }
        clipArr.push(picsmall)
        arr.push(obj)
      }

      var storeImg = this.storeimg
      if (storeImg.length > 0) {
        for (var j = 0; j < storeImg.length; j++) {
          switch (storeImg[j]['name']) {
            case _name:
              storeImg[j]['children'] = arr
              break;
            default:
              storeImg.push({
                name: _name,
                children: arr
              })
              break;
          }
        }
      } else {
        storeImg.push({
          name: _name,
          children: arr
        })
      }
      ////console.log(clipArr)
      this.storeimg = storeImg
      if (a.state == 'remove') {

      } else {
        this.conImgList = clipArr
        this.showpicModal = true
        this.setUrl(clipArr[0], 0)
      }
      var resulturl = clipArr.join(',')
      that.$set(that.formItem, 'thum', resulturl)
    },
    upImglist1 (a, b, c) {
      ////console.log(a, b, c)

      var that = this
      that.btntype = 2
      var _name = a.name
      var pics = a.pics
      var arr = []
      var clipArr = []
      for (var i = 0; i < pics.length; i++) {
        var item = pics[i]['response']['url']
        var pic = item.split("@")[1]
        var picsmall = item.split("@")[0]
        var obj = {
          pic: pic,
          picsmall: picsmall,
        }
        clipArr.push(picsmall)
        arr.push(obj)
      }

      var storeImg = this.storeimg1
      if (storeImg.length > 0) {
        for (var j = 0; j < storeImg.length; j++) {
          switch (storeImg[j]['name']) {
            case _name:
              storeImg[j]['children'] = arr
              break;
            default:
              storeImg.push({
                name: _name,
                children: arr
              })
              break;
          }
        }
      } else {
        storeImg.push({
          name: _name,
          children: arr
        })
      }
      ////console.log(clipArr)
      this.storeimg1 = storeImg
      if (a.state == 'remove') {

      } else {
        this.conImgList = clipArr
        this.showpicModal = true
        this.setUrl(clipArr[0], 0)
      }
      var resulturl = clipArr.join(',')

      that.$set(that.formItem, 'pic1', resulturl)
    },
    upImglist2 (a, b, c) {
      ////console.log(a, b, c)

      var that = this
      that.btntype = 3
      var _name = a.name
      var pics = a.pics
      var arr = []
      var clipArr = []
      for (var i = 0; i < pics.length; i++) {
        var item = pics[i]['response']['url']
        var pic = item.split("@")[1]
        var picsmall = item.split("@")[0]
        var obj = {
          pic: pic,
          picsmall: picsmall,
        }
        clipArr.push(picsmall)
        arr.push(obj)
      }

      var storeImg = this.storeimg2
      if (storeImg.length > 0) {
        for (var j = 0; j < storeImg.length; j++) {
          switch (storeImg[j]['name']) {
            case _name:
              storeImg[j]['children'] = arr
              break;
            default:
              storeImg.push({
                name: _name,
                children: arr
              })
              break;
          }
        }
      } else {
        storeImg.push({
          name: _name,
          children: arr
        })
      }
      ////console.log(clipArr)
      this.storeimg2 = storeImg
      if (a.state == 'remove') {

      } else {
        this.conImgList = clipArr
        this.showpicModal2 = true
        this.setUrl(clipArr[0], 0)
      }
      var resulturl = clipArr.join(',')

      that.$set(that.formItem, 'pic2', resulturl)
    },
    compareTIME (date) {

      var now = new Date;
      var d = new Date(date);
      if (now > d) {
        return true
      } else if (now < d) {
        return false
      } else {
        return true
      }

    },
    getcurTime () {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = month > 9 ? month : '0' + month
      var day = date.getDate()
      day = day > 9 ? day : '0' + day
      var hour = date.getHours()
      hour = hour > 9 ? hour : '0' + hour
      var mm = date.getMinutes()
      mm = mm > 9 ? mm : '0' + mm
      return year + '-' + month + '-' + day + ' ' + hour + ':' + mm
    },
    removeItem () {
      var that = this
      ////console.log(this.curItem.guid)
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否删除此条新闻？</p>',
        onOk: () => {
          that.axios.post('news/delete', {
            id: this.curItem.guid
          }).then(res => {
            ////console.log(res)
            that.$Message.success(res.msg)
            that.edit = false
            that.reloadTable()
            that.curItem = {}

          }).catch(function (res) {
            that.$Message.error('未知问题')
          })
        },
        onCancel: () => {

        }
      });

    },
    searchData () {
      ////console.log('searchData')
      this.issearch = Math.random()
    },
    sModal (guid) {
      //console.log(guid, 'guid', this.formData[0][0])
      var that = this
      this.ordertime = false
      this.edit = true
      this.treekey = this.reloadTmep = Math.random()
      this.lanmu = []
      this.formItem = JSON.parse(JSON.stringify(this.initformItem))
      this.olditemid = ''
      var curtime = this.getcurTime()
      this.$set(this.formItem, 'pubtime', curtime)
      this.$set(this.formItem, 'showtime', curtime)
      this.$set(this.formItem, 'content', '')
      this.addtings = {
        url: '',
        filetype: -1
      }
      utilMethod.checkToken()
      if (guid == -1) {
        setTimeout(function () {
          that.$set(that.formItem, 'content', ' ')
        }, 200)
      }
      setTimeout(function () {
        //console.log(that.formItem,'this.formitem')
      }, 200)

    },
    renderTime (date) {
      var dates = new Date(date).toJSON();
      return new Date(+new Date(dates) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/,
        '')
    },

    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  position: absolute;
  right: 0px;
  top: 5px;
}


.send {
  cursor: pointer;
  width: 285px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #E22A1C;
  border-radius: 4px;
  letter-spacing: 1px;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  display: block;
  margin: 0 auto;
}

.commonCon {
  padding-right: 20px;
  /* 	overflow: scroll; */
  overflow-x: hidden;
  background: #fff;

}

.ConLeft {
  width: 45%;
  margin: 30px auto;
}

#con {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

#con>section {
  width: 47%;
}

#con .ConRight {
  margin-top: 30px;

}

>>>.ivu-checkbox-checked .ivu-checkbox-inner {

  border-color: #E22A1C !important;
  background-color: #E22A1C !important;
}

>>>.ivu-checkbox-focus,
>>>.ivu-switch:focus {
  -webkit-box-shadow: 0 0 0 2px rgba(226, 42, 28, .1);
  box-shadow: 0 0 0 2px rgba(226, 42, 28, .1);

}

>>>.ivu-switch-checked {
  border-color: #E22A1C !important;
  background-color: #E22A1C !important
}

>>>.ivu-date-picker {
  width: 100%;
}

.remove {
  float: left;
}

.conheadRight button {}

#pdData {
  display: flex;
  justify-content: flex-start;

}

.itempd {

  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}

#ifrmePage {
  width: 92%;
  height: 300px;
  margin: 0 auto;
}

#ifrmePage frame {
  width: 100%;
  height: 100%;
}

#croppicConten {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

#croppicConten ul {
  width: 140px;

}

#croppicConten ul li {
  list-style: none;
  padding: 0px 5px 0px 2px;
}

#croppicConten ul li img {
  width: 120px;
  height: 90px;
  border: 3px solid #ddd;
  margin-bottom: 10px;
  margin-right: 10px;
}

#croppicConten ul li.active img {
  border: 3px solid orange
}

#QRCode_header {
  position: absolute;
  right: 50px;
  bottom: 10px;
}

#copyLink {
  position: absolute;
  left: 30px;
  bottom: 10px;
}

.pdData {
  display: flex;
  justify-content: flex-start;
  list-style: none;
  flex-wrap: wrap;
}

.itempd {
  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}

.gallerylist {
  padding: 20px 0px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

}

.gallerylist li {
  list-style: none;
  width: 20%;

  height: auto;
  margin-bottom: 30px;
  padding: 10px;
  box-sizing: border-box;

}

.gallerylist li>div:hover {
  top: -6px;
}

.gallerylist li>div {
  transition: all 2s;
  cursor: pointer;
  position: relative;
  width: 200px;
  height: 200px;
  box-shadow: 0px 2px 10px 0px rgba(229, 229, 229, .8);
  border-radius: 4px;
  overflow: hidden;
  margin: 0 auto;
  box-sizing: border-box;
  background: #fff;
}

.gallerylist li>div>div>div {

  text-align: center;
  margin-top: 7px;
  width: 100%;

  color: #333;
}

.gallerylist li .gallerylistcontent {
  background: #fff;
  border-radius: 5px;
  padding: 4px;
}

.gallerylist li div div div div {
  color: #a4a6bd;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  padding: 0px 10px;
  font-size: 12px;
  margin-top: 4px;
}

.gallerylist li p {
  padding: 0px 10px;
  margin-top: 8px;
  color: #515a6e;
  display: flex;
  justify-content: space-between;

}

.gallerylist li p span:first-of-type {
  font-weight: bold;
}

.gallerylist li p span:last-of-type {
  color: #888;
  font-size: 12px;
  position: relative;
  top: 3px;
}

.gallerylist li img {
  width: 100%;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 130px;
}

.gallerylist li video {
  width: 100%;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 130px;
}

.gallerylist li audio {
  width: 100%;

  height: 130px;

}

.removePhoto {
  position: absolute;
  top: 0px;
  right: 0px;
  /* 	background:rgba(0,0,0,.5); */
  padding: 5px 10px;
  width: 100%;
  z-index: 2000;
}

.removePhoto label {
  color: rgba(255, 255, 255, .7);
  font-size: 12px;

}

.exp {
  float: left;
  line-height: 30px;
}

.lbcon .piclist {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.lbcon .piclist .slide {
  width: 22%;
  margin: 10px;
}
</style>
